import {combineEpics} from 'web-app/util/redux-observable';

import presetEpics from './presets/epics';

export default combineEpics(presetEpics);
